import type { ElementBase } from "@/elementBase";
import type { ShapeWidget } from "@/elements/shape";
import type { StickerWidget } from "@/elements/sticker";
import type { TableWidget } from "@/elements/table/table";
import type { TextWidgetV2 } from "@/elements/text/textV2";
import type { Group } from "@/group";
import { MIN_NUMBER_OF_SYMBOLS } from "../constants/aiConstants";
import type { AiModes } from "../types";

type AiAssistantSupportedWidget = TableWidget | StickerWidget | ShapeWidget | TextWidgetV2;

const isAiAssistantSupportedWidget = (
    widget: ElementBase,
): widget is AiAssistantSupportedWidget => {
    switch (widget.constructorName) {
        case "table":
        case "sticker":
        case "shape":
        case "textV2":
            return true;

        default:
            return false;
    }
};

function isWidgetWithEnoughText(widget: AiAssistantSupportedWidget): boolean {
    switch (widget.constructorName) {
        case "table": {
            let result = true;
            outer: for (const row of widget.rows) {
                for (const cell of row.cells) {
                    if (cell.textPart.symbolsCount === 0) {
                        result = false;
                        break outer;
                    }
                }
            }

            return result;
        }

        case "sticker":
        case "shape":
            return widget.textPart.symbolsCount > MIN_NUMBER_OF_SYMBOLS;
        case "textV2":
            return widget.symbolsCount > MIN_NUMBER_OF_SYMBOLS;
        default:
            return false;
    }
}

export function processSelectedWidgets(groups: Group[], mode: AiModes) {
    //Для включения механизма undo/redo для ai фич нужно расскоментировать строки

    const result: {
        widgetsState: {
            [UID: string]: unknown;
        };
        widgetUIDs: string[];
    } = {
        widgetUIDs: [],
        widgetsState: {},
    };

    /* const fixType = mode === "create" ? "full" : "bold"; */

    for (const group of groups) {
        if (group.isItemWrapper()) {
            const widget = group.children[0] as ElementBase;

            if (isAiAssistantSupportedWidget(widget) && isWidgetWithEnoughText(widget)) {
                /* result.widgetsState[group.children[0].UID] = group.children[0].getState(fixType); */
                result.widgetUIDs.push(widget.UID);
            }

            continue;
        }

        (group.children as Group[]).forEach((child) => {
            if (child.isItemWrapper()) {
                const widget = child.children[0] as ElementBase;

                if (isAiAssistantSupportedWidget(widget) && isWidgetWithEnoughText(widget)) {
                    /* result.widgetsState[child.children[0].UID] = child.children[0].getState(fixType); */
                    result.widgetUIDs.push(widget.UID);
                }

                return;
            }

            (child.children as Group[]).forEach((innerChild) => {
                const widget = innerChild.children[0] as ElementBase;

                if (isAiAssistantSupportedWidget(widget) && isWidgetWithEnoughText(widget)) {
                    /* result.widgetsState[innerChild.children[0].UID] =
                        innerChild.children[0].getState(fixType); */
                    result.widgetUIDs.push(widget.UID);
                }
            });
        });
    }

    return result;
}
